import {
  Text,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useDisclosure,
} from '@chakra-ui/react';
import { CustomMeatballIcon } from '../../../theme/icons/CustomMeatballIcon';
import ChangeRole from './ChangeRole';
import DeleteAccount from './DeleteAccount';
import { useIsReadOnly } from '../../../hooks/useIsReadOnly';
import { useState } from 'react';

const TeamInvitationsOptions = ({ invitation }) => {
  const isReadOnly = useIsReadOnly();
  const [isDeleting, setIsDeleting] = useState(false);
  const {
    isOpen: isRoleModalOpen,
    onOpen: onOpenRoleModal,
    onClose: onCloseRoleModal,
  } = useDisclosure();
  const {
    isOpen: isDeleteModalOpen,
    onOpen: onOpenDeleteModal,
    onClose: onCloseDeleteModal,
  } = useDisclosure();

  const handleCloseDeleteModal = () => {
    if (!isDeleting) {
      onCloseDeleteModal();
    }
  };

  return (
    <Menu autoSelect={false} isDisabled={isDeleting}>
      <MenuButton
        as={IconButton}
        aria-label="Options"
        icon={
          <CustomMeatballIcon
            color={isDeleting ? 'gray.300' : 'secondaryDark08'}
          />
        }
        variant="link"
        size="sm"
        isDisabled={isDeleting}
      />
      <MenuList>
        <MenuItem
          _hover={{ bg: 'quinaryBackground' }}
          onClick={() => {
            onOpenRoleModal();
          }}
          isDisabled={isDeleting || isReadOnly}
        >
          <ChangeRole
            isOpen={isRoleModalOpen}
            onClose={onCloseRoleModal}
            selectedAccount={invitation}
            text="Change Role"
          />
        </MenuItem>
        <MenuItem
          _hover={{ bg: 'quinaryBackground' }}
          color="error"
          onClick={() => {
            onOpenDeleteModal();
          }}
          isDisabled={isDeleting || isReadOnly}
        >
          <DeleteAccount
            isOpen={isDeleteModalOpen}
            onClose={handleCloseDeleteModal}
            selectedAccount={invitation}
            text="Delete"
            setIsDeleting={setIsDeleting}
          />
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default TeamInvitationsOptions;
